<div class="ava_payment_methods">
    <h4 
        [ngClass]="[class || '']"
        class="title_list label_lg_bold"
    >
        طرق الدفع المتاحة
    </h4>
    <ul class="methods_pay list_none mb-0">
        <li 
            class="border_r_2th border_def_2th"
        >
            <div class="wrap_img d-inline-block">
                <img src="../../../../assets/img/visa.svg" alt="">
            </div>
            <span class="text text_md_bold">فيزا وماستر كارد</span>
        </li>
        <li 
            class="border_r_2th border_def_2th"
        >
            <div class="wrap_img d-inline-block">
                <img src="../../../../assets/img/mada.svg" alt="">
            </div>
            <span class="text text_md_bold">مدى</span>
        </li>
        <li 
            class="border_r_2th border_def_2th"
        >
            <div class="wrap_img d-inline-block">
                <img src="../../../../assets/img/Apple_Pay.svg" alt="">
            </div>
            <span class="text text_md_bold">ابل باي</span>
        </li>                        
    </ul>
</div>